/**
 * クラス名：お客様・仕入先パラメータ
 * 説明：お客様・仕入先情報一覧画面
 * 作成者：ケイ
 * 作成日：2023/05/01
 * バージョン：1.0
 */
import {
  Table,
  Form,
  Button,
  Row,
  Input,
  Col,
  Modal,
  Select,
  Checkbox,
  Space,
  Image,
  Radio,
  DatePicker,
  Spin,
} from 'antd';
import { Table as RTable } from 'react-bootstrap';
import { CSVLink, CSVDownload } from 'react-csv';
import React, { useState, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';
import { Outlet, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import SplitPane, { Pane } from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css';
import { StatusCodes } from 'http-status-codes';

import { ClientType } from '../../../common/enums';
import CustomerSupplierDetails from './CustomerSupplierDetails';
import '../../../../assets/styles/common.css';
import checked from '../../../../assets/images/checked.png';
import {
  confirmHakiContent,
  confirmUpdateContent,
  confirmDiscardContent,
  confirmCreateContent,
  confirmModalTitle,
  confirmDeleteContent,
  confirmDiscardAndDeleteContent,
  commonModal,
  commonFooter,
  error,
  authorizeError,
  commonDeleteFooter,
  commonResponsiveConfirmModal,
  bulkDeleteModalTitle,
  complete,
  BulkDeleteModal,
  deleteModalTitle,
  commonDeleteAllFooter,
} from '../../../common/CommonModal';
import {
  dataStateList,
  today,
  flgStateList,
  TextArea,
  formatDate,
  updateAccessToken,
  formValidatorMode,
  toDecimal,
  ResizableTitle,
  isCustomer,
  isSupplier,
  isContractor,
  getAccessToken,
  handleKeyPress,
  regexExp,
  toHalfWidth,
  isDecimal,
  formatDateString,
  todayTime,
  isEmail,
  isTelAndFax,
  isDigit,
  discardChange,
} from '../../../common/Common';
import { createClientCSV, getClientInfo, getMaxCode } from '../../../common/CommonAPI';
import { ErrorMessage } from '../../../common/Message';
import filter_clear_icon from '../../../../assets/images/filter_clear_icon.png';
import { NOT_CHANGE, pageSizes } from '../../../common/Constant';
import sort_up from '../../../../assets/images/sort_up.png';
import sort_down from '../../../../assets/images/sort_down.png';
import Draggable from 'react-draggable';
import { CloseOutlined } from '@ant-design/icons';

dayjs.extend(customParseFormat);
const RadioGroup = Radio.Group;
const dateFormat = 'YYYY-MM-DD';

const CustomerSupplierParamList = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    setSplitPaneSize: setSplitPaneSize,
    createNewProcess: createNewProcess,
    showXMLInputModal: showXMLInputModal,
    bulkEditProcess: bulkEditProcess,
    deleteProcess: deleteProcess,
    bulkDeleteProcess: bulkDeleteProcess, // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
    deleteAllProcess: deleteAllProcess,
    showCSVInputModal: showCSVInputModal,
    getEditMode: editMode,
    updateEditMode: setEditMode,
    discardChange: discardChange,
    setDiscardChangeMode: setDiscardChangeMode,
    setEditModeCancelConfirm: setEditModeCancelConfirm,
    discardConfirmOk: discardConfirmOk,
    // setShowEdtConfirmOK: setShowEdtConfirmOK,
    getCsvExportFileName: csvExportFileName,
    getCsvExportData: getCsvExportData,
    submitCsvImportData: submitCsvImportData,
  }));

  const inputItemRef = {};

  let checkedRow = [];
  const detailRef = useRef();

  const messageRef = useRef([]);

  const navigate = useNavigate();
  const location = useLocation();
  // デフォルトページの表示件数
  const defaultPageSize = 25;

  let loginUser = JSON.parse(decodeURI(localStorage?.getItem('iQxWeb_LoginUser')));
  let token = localStorage?.getItem('iQxWeb_AccessToken');
  let partType = ['customer', 'supplier'];

  const discardChangePart = [{ no: 99, state: 'changePart' }];

  const [paramSelected, setParamSelected] = useState(partType[0]);
  const [paramType, setParamType] = useState('common');
  const [activePartMenu, setActivePartMenu] = useState(partType[0]);
  const [changePartName, setChangePartName] = useState(partType[0]);

  const [customersData, setCustomersData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [tempCustomersData, setTempCustomersData] = useState([]);

  const [editMode, setEditMode] = useState(false);
  // 発生した処理タイプ
  const [discardChangeMode, setDiscardChangeMode] = useState();
  const [cusSelectedRowId, setCusSelectedRowId] = useState([]);
  const [supSelectedRowId, setSupSelectedRowId] = useState([]);
  const [changeRecordId, setChangeRecordId] = useState(0);

  const [cusCurrentPage, setCusCurrentPage] = useState(1);
  const [supCurrentPage, setSupCurrentPage] = useState(1);

  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [created, setCreated] = useState('');
  const [modified, setModified] = useState('');
  const [modifier, setModifier] = useState('');
  const [customerFlg, setCustomerFlg] = useState(false);
  const [supplierFlg, setSupplierFlg] = useState(false);
  const [contractorFlg, setContractorFlg] = useState(false);
  const [customerCoefficients, setCustomerCoefficients] = useState('');
  const [supplierCoefficients, setSupplierCoefficients] = useState('');
  const [contractorCoefficients, setContractorCoefficients] = useState('');

  const [isUsed, setIsUsed] = useState();
  const [branchNum, setBranchNum] = useState();
  const [nameKana, setNameKana] = useState('');
  const [tel, setTel] = useState('');
  const [fax, setFax] = useState('');
  const [contactParson, setContactParson] = useState('');
  const [mail, setMail] = useState('');
  const [zip, setZip] = useState('');
  const [prefecture, setPrefecture] = useState('');
  const [address, setAddress] = useState('');
  const [remarks, setRemarks] = useState('');
  const [sortNum, setSortNum] = useState();

  const [dataState, setDataState] = useState(1);
  const [customerFlgState, setCustomerFlgState] = useState(0);
  const [supplierFlgState, setSupplierFlgState] = useState(0);
  const [contractorFlgState, setContractorFlgState] = useState(0);
  const [customerCoeff, setCustomerCoeff] = useState();
  const [supplierCoeff, setSupplierCoeff] = useState();
  const [outsourcerCoeff, setOutsourcerCoeff] = useState();
  const [keyword, setKeyWord] = useState('');

  const [hasCheckData, setHasCheckData] = useState(true);
  const [chkData, setChkData] = useState(0);

  const [selectedRowsData, setSelectedRowsData] = useState([]);

  const [isBulkEdit, setIsBulkEdit] = useState(false);
  const [isCreateNew, setIsCreateNew] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [visibleCSVInput, setVisibleCSVInput] = useState(false);
  const [visibleCSVOutput, setVisibleCSVOutput] = useState(false);
  const [visibleXMLInput, setVisibleXMLInput] = useState(false);
  const [childTitle, setChildTitle] = useState('');

  const [createConfirm, setCreateConfirm] = useState(false);
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [updateConfirm, setUpdateConfirm] = useState(false);
  const [editModeCancelConfirm, setEditModeCancelConfirm] = useState(false);

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  // 一括削除
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const [deleteSelectedRowKeys, setDeleteSelectedRowKeys] = useState([]);

  const [isDeleteAll, setIsDeleteAll] = useState(false);

  // 一括編集
  const [chkrowscount, setChkRowsCount] = useState(0);
  const [bulkEditSelectedRow, setBulkEditSelectedRow] = useState([]);
  const [bulkEditSelectedRowId, setBulkEditSelectedRowId] = useState([]);
  const [tmpFilteredData, setTmpFilteredData] = useState();
  const [isUsedEdit, setIsUsedEdit] = useState(0);

  // Content Resize
  const [sizes, setSizes] = useState(['60%']);

  //　テーブル列Resizable用変数
  // 一覧用変数
  const [nameWidth, setNameWidth] = useState(150);
  const [nameKanaWidth, setNameKanaWidth] = useState(150);
  const [telWidth, setTelWidth] = useState(125);
  const [faxWidth, setFaxWidth] = useState(125);
  const [contactParsonWidth, setContactParsonWidth] = useState(125);
  const [mailWidth, setMailWidth] = useState(150);
  const [zipWidth, setZipWidth] = useState(100);
  const [prefectureWidth, setPrefectureWidth] = useState(150);
  const [addressWidth, setAddressWidth] = useState(150);
  const [remarkWidth, setRemarkWidth] = useState(200);
  // 一括編集用変数
  const [nameWidthEdit, setNameWidthEdit] = useState(150);
  const [nameKanaWidthEdit, setNameKanaWidthEdit] = useState(150);
  const [telWidthEdit, setTelWidthEdit] = useState(125);
  const [faxWidthEdit, setFaxWidthEdit] = useState(125);
  const [contactParsonWidthEdit, setContactParsonWidthEdit] = useState(125);
  const [mailWidthEdit, setMailWidthEdit] = useState(150);
  const [zipWidthEdit, setZipWidthEdit] = useState(100);
  const [prefectureWidthEdit, setPrefectureWidthEdit] = useState(150);
  const [addressWidthEdit, setAddressWidthEdit] = useState(150);
  const [remarkWidthEdit, setRemarkWidthEdit] = useState(200);

  const [showEdtConfirmOK, setShowEdtConfirmOK] = useState();
  const [showEdtConfirmCancle, setShowEdtConfirmCancle] = useState();

  const csvExportFileName = `お客様・仕入れ先_${formatDateString(todayTime())}.csv`;

  // pagination
  const [pageSize, setPageSize] = useState(30);
  const [editPageSize, setEditPageSize] = useState(30);
  const [editPage, setEditPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [ascSortFlg, setAscSortFlg] = useState('ASC');
  const [sortNm, setSortNm] = useState('id');
  const [filterDatas, setFilterDatas] = useState({
    customerFlgState: 0,
    supplierFlgState: 0,
    contractorFlgState: 0,
    keyword: '',
    isUsedFlg: 1,
  });
  const [tblLoading, setTblLoading] = useState(false);
  const [isFilterFlg, setIsFilterFlg] = useState(false);

  // 2025-05-20 ブラウザのテキストの拡大率が100％の場合、ページを変える部分(1番下)が、
  // ブラウザを最大化していないと表示されない。90％以下であれば最大化していなくても表示される。
  // 縮小しても表示されるようにしてもらえたらありがたいです。
  const [tableScrollY, setTableScrollY] = useState(500);
  const updateTableHeight = () => {
    const searchHeight = 40;
    const footerHeight = 150;
    const availableHeight = window.innerHeight - searchHeight - footerHeight - 48; // 48 is margin
    setTableScrollY(availableHeight);
  };

  useEffect(() => {
    updateTableHeight();
    window.addEventListener('resize', updateTableHeight);
    return () => window.removeEventListener('resize', updateTableHeight);
  }, []);

  useEffect(() => {
    getClientData();
  }, [paramType, paramSelected]);

  // フラグ又はキーワードに変更された場合、
  useEffect(() => {
    if (isFilterFlg) {
      // 絞り込み、
      getDataByFilter();
    }
  }, [keyword, dataState, customerFlgState, supplierFlgState, contractorFlgState, tmpFilteredData]);

  useEffect(() => {
    if (props.showConfirmMsgs !== undefined) {
      setShowEdtConfirmOK(props.showConfirmMsgs?.editOk);
      setShowEdtConfirmCancle(props.showConfirmMsgs?.editCancel);
    } else {
      setShowEdtConfirmOK(true);
      setShowEdtConfirmCancle(true);
    }
  }, [props.showConfirmMsgs]);

  // 編集中破棄確認ポップアップに「OK」又は「キャンセル」を押下
  useEffect(() => {
    let currentData = [];
    let selectedData;
    let id = '';
    if (!editMode && !editModeCancelConfirm) {
      currentData = getCurrentData();
      switch (discardChangeMode?.no) {
        case discardChange[0]?.no: // 編集中に行を選択した場合、
          id = changeRecordId;
          setSelectedRowId(id);
          selectedData = getSelectedData(currentData, id);
          setSelectedData(selectedData);
          break;
        case discardChange[1]?.no: // 検索
          getDataByFilter();
          break;
        case discardChange[2]?.no: // 一括編集
        case discardChange[3]?.no: // 新規作成
          id = getSelectedRowId();
          selectedData = getSelectedData(currentData, id);
          setSelectedData(selectedData);
          discardChangeMode?.no === discardChange[2]?.no ? bulkEditProcess() : createNewProcess();
          break;
        case discardChangePart[0]?.no: //　編集中に「お客様・仕入先」を変更した場合、
          //setActivePartMenu(changePartName);
          getDataByFilter(changePartName);
          break;
        case discardChange[4]?.no: // CSV入力
          onClickCSVImport();
          break;
        case discardChange[5]?.no: // CSV出力
          onClickCSVExport();
          break;
      }
    }
  }, [editModeCancelConfirm]);

  // 取引先情報をDBから取得する
  async function getClientData() {
    let clientsData = [];
    let selectedData = [];
    let customersData = [];
    let supplierData = [];
    props?.loading(true); // Waitingダイアログを表示にする
    try {
      let pageBefore =
        props.initialParam === 'customer' && props?.rowSelectPage !== undefined && props?.rowSelectPage !== 0
          ? props?.rowSelectPage - 1
          : 0;
      setCusCurrentPage(pageBefore === 0 ? 1 : props?.rowSelectPage);
      let propSortFlg =
        props.initialParam === 'customer' && props?.ascSortFlg !== undefined ? props?.ascSortFlg : ascSortFlg;
      let propSortNm = props.initialParam === 'customer' && props?.sortNm !== undefined ? props?.sortNm : sortNm;
      let propFilterDatas =
        props.initialParam === 'customer' && props?.filterDatas !== undefined ? props?.filterDatas : filterDatas;
      let clientInfos = await getClientInfo(pageSize, pageBefore, propSortFlg, propSortNm, propFilterDatas);
      if (clientInfos) {
        clientsData = clientInfos ? clientInfos?.data : [];
        setTotalCount(clientInfos?.totalCount);
      }

      customersData = clientsData; /* ?.filter((record) => record.clientType === ClientType.Customer); */
      supplierData = clientsData; /* ?.filter((record) => record.clientType === ClientType.Supplier); */

      if (customersData?.length > 0) selectedData = customersData?.[0];
      // 前回選択された行がある場合
      if (props.initialParam === 'customer' && props.selectedRowId !== undefined && props.selectedRowId !== 0) {
        selectedData = clientsData?.filter((item) => item.id === props?.selectedRowId)?.[0];
        selectedData = selectedData ? selectedData : customersData?.[0];
        if (propFilterDatas?.customerFlgState !== undefined) setCustomerFlgState(propFilterDatas?.customerFlgState);
        if (propFilterDatas?.supplierFlgState !== undefined) setSupplierFlgState(propFilterDatas?.supplierFlgState);
        if (propFilterDatas?.contractorFlgState !== undefined)
          setContractorFlgState(propFilterDatas?.contractorFlgState);
        if (propFilterDatas?.keyword !== undefined) setKeyWord(propFilterDatas?.keyword);
        if (propFilterDatas?.isUsedFlg !== undefined) setDataState(propFilterDatas?.isUsedFlg);
        setFilterDatas(propFilterDatas);
      }

      setCustomersData(customersData);
      setSupplierData(supplierData);
      setFilteredData(customersData);

      setCusSelectedRowId(selectedData?.id);
      setSupSelectedRowId(supplierData?.[0]?.id);

      setSelectedData(selectedData);
      setSelectedRowsData(selectedData);

      navigate(':common.customer');
      setParamSelected(partType?.[0]);
      setParamType('common');
      props.setParam(paramType, paramSelected);
    } catch (e) {
      error(e.message);
      return;
    }
    props?.loading(false); // Waitingダイアログを非表示にする
  }

  const columns = [
    {
      id: '1',
      title: 'No',
      dataIndex: 'no',
      width: 55,
      render: (id, record, index) => {
        let pageBefore = cusCurrentPage - 1;
        let startPage = pageBefore < 0 ? 0 : pageSize * pageBefore;
        return startPage + (index + 1); // IQX_WEBEST-240
      },
      className: 'cm-a-right',
      key: 'no',
    },
    {
      id: '2',
      title: 'コード',
      dataIndex: 'code',
      width: 120,
      onFilter: (value, record) => record[dataIndex].toString().toLowerCase()?.includes(value.toLowerCase()),
      sorter: (a, b) => setSortNm('code'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'code',
    },
    {
      id: '3',
      title: '枝番',
      dataIndex: 'info',
      width: 90,
      render: (info) => info.branchNum,
      sorter: (a, b) => setSortNm('branchNum'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'branchNum',
    },
    {
      id: '4',
      title: '名称',
      dataIndex: 'name',
      width: isBulkEdit ? nameWidthEdit : nameWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (isBulkEdit) {
            setNameWidthEdit(size.width);
          } else {
            setNameWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('name'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'name',
    },
    {
      id: '5',
      title: 'カナ',
      dataIndex: 'info',
      render: (info) => info.nameKana,
      width: isBulkEdit ? nameKanaWidthEdit : nameKanaWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (isBulkEdit) {
            setNameKanaWidthEdit(size.width);
          } else {
            setNameKanaWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('nameKana'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'nameKana',
    },
    {
      id: '6',
      title: 'お客様',
      dataIndex: 'clientType',
      width: 95,
      render: (value) => {
        return (
          <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }}>
              {isCustomer(value) === true ? (
                <Image preview={false} width={13} src={checked} style={{ marginRight: '5px' }} />
              ) : (
                <></>
              )}
            </div>
          </div>
        );
      },
      className: 'cm-a-center',
      sorter: (a, b) => (isCustomer(a.clientType) === true ? 1 : 0) - (isCustomer(b.clientType) === true ? 1 : 0),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'clientType',
    },
    {
      id: '7',
      title: 'お客様係数',
      dataIndex: 'coeffClients',
      width: 95,
      render: (coeffClients, data) =>
        isCustomer(data.clientType) === true ? (
          parseFloat(coeffClients?.filter((record) => record.clientType === ClientType.Customer)?.[0]?.coeff).toFixed(2)
        ) : (
          <></>
        ),
      sorter: (a, b) =>
        parseFloat(a.coeffClients?.filter((record) => record.clientType === ClientType.Customer)?.[0]?.coeff).toFixed(
          2
        ) -
        parseFloat(b.coeffClients?.filter((record) => record.clientType === ClientType.Customer)?.[0]?.coeff).toFixed(
          2
        ),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'customCoeff',
    },
    {
      id: '8',
      title: '仕入先',
      dataIndex: 'clientType',
      width: 95,
      render: (value) => {
        return (
          <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }}>
              {isSupplier(value) === true ? (
                <Image preview={false} width={13} src={checked} style={{ marginRight: '5px' }} />
              ) : (
                <></>
              )}
            </div>
          </div>
        );
      },
      className: 'cm-a-center',
      sorter: (a, b) => (isSupplier(a.clientType) === true ? 1 : 0) - (isSupplier(b.clientType) === true ? 1 : 0),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'supplierType',
    },
    {
      id: '9',
      title: '仕入先係数',
      dataIndex: 'coeffClients',
      width: 95,
      render: (coeffClients, data) =>
        isSupplier(data.clientType) === true ? (
          parseFloat(coeffClients?.filter((record) => record.clientType === ClientType.Supplier)?.[0]?.coeff).toFixed(2)
        ) : (
          <></>
        ),
      sorter: (a, b) =>
        parseFloat(a.coeffClients?.filter((record) => record.clientType === ClientType.Supplier)?.[0]?.coeff).toFixed(
          2
        ) -
        parseFloat(b.coeffClients?.filter((record) => record.clientType === ClientType.Supplier)?.[0]?.coeff).toFixed(
          2
        ),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'supplierCoeff',
    },
    {
      id: '10',
      title: '委託先',
      dataIndex: 'clientType',
      width: 95,
      render: (value) => {
        return (
          <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }}>
              {isContractor(value) === true ? (
                <Image preview={false} width={13} src={checked} style={{ marginRight: '5px' }} />
              ) : (
                <></>
              )}
            </div>
          </div>
        );
      },
      className: 'cm-a-center',
      sorter: (a, b) => (isContractor(a.clientType) === true ? 1 : 0) - (isContractor(b.clientType) === true ? 1 : 0),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'contractorType',
    },
    {
      id: '11',
      title: '委託先係数',
      dataIndex: 'coeffClients',
      width: 95,
      render: (coeffClients, data) =>
        isContractor(data.clientType) === true ? (
          parseFloat(coeffClients?.filter((record) => record.clientType === ClientType.Contractor)?.[0]?.coeff).toFixed(
            2
          )
        ) : (
          <></>
        ),
      sorter: (a, b) =>
        parseFloat(a.coeffClients?.filter((record) => record.clientType === ClientType.Contractor)?.[0]?.coeff).toFixed(
          2
        ) -
        parseFloat(b.coeffClients?.filter((record) => record.clientType === ClientType.Contractor)?.[0]?.coeff).toFixed(
          2
        ),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'contractorCoeff',
    },
    {
      id: '12',
      title: 'Tel',
      dataIndex: 'info',
      render: (info) => info.tel,
      width: isBulkEdit ? telWidthEdit : telWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (isBulkEdit) {
            setTelWidthEdit(size.width);
          } else {
            setTelWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('tel'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'tel',
    },
    {
      id: '13',
      title: 'Fax',
      dataIndex: 'info',
      render: (info) => info.fax,
      width: isBulkEdit ? faxWidthEdit : faxWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (isBulkEdit) {
            setFaxWidthEdit(size.width);
          } else {
            setFaxWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('fax'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'fax',
    },
    {
      id: '14',
      title: '担当者',
      dataIndex: 'info',
      render: (info) => info.contactParson,
      width: isBulkEdit ? contactParsonWidthEdit : contactParsonWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (isBulkEdit) {
            setContactParsonWidthEdit(size.width);
          } else {
            setContactParsonWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('contactParson'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'contactParson',
    },
    {
      id: '15',
      title: 'メール',
      dataIndex: 'info',
      render: (info) => info.mail,
      width: isBulkEdit ? mailWidthEdit : mailWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (isBulkEdit) {
            setMailWidthEdit(size.width);
          } else {
            setMailWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('mail'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'mail',
    },
    {
      id: '16',
      title: '郵便番号',
      dataIndex: 'info',
      width: 100,
      render: (info) => info.zip,
      width: isBulkEdit ? zipWidthEdit : zipWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (isBulkEdit) {
            setZipWidthEdit(size.width);
          } else {
            setZipWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('zip'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'zip',
    },
    {
      id: '17',
      title: '都道府県',
      dataIndex: 'info',
      render: (info) => info.prefecture,
      width: isBulkEdit ? prefectureWidthEdit : prefectureWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (isBulkEdit) {
            setPrefectureWidthEdit(size.width);
          } else {
            setPrefectureWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('prefecture'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'prefecture',
    },
    {
      id: '18',
      title: '住所',
      dataIndex: 'info',
      width: isBulkEdit ? addressWidthEdit : addressWidth,
      render: (info) => info.address,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (isBulkEdit) {
            setAddressWidthEdit(size.width);
          } else {
            setAddressWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('address'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'address',
    },

    {
      id: '19',
      title: 'ソート番号',
      dataIndex: 'info',
      width: 95,
      className: 'cm-a-right',
      render: (info) => info.sortNum,
      sorter: (a, b) => setSortNm('sortNum'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'sortNum',
    },
    {
      id: '20',
      title: '作成日',
      dataIndex: 'created',
      width: 100,
      render: (created) => formatDate(created),
      sorter: (a, b) => setSortNm('created'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'created',
    },
    {
      id: '21',
      title: '更新日',
      dataIndex: 'modified',
      width: 100,
      render: (modified) => formatDate(modified),
      sorter: (a, b) => setSortNm('modified'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'modified',
    },
    {
      id: '22',
      title: '更新者',
      dataIndex: 'modifier',
      width: 150,
      sorter: (a, b) => setSortNm('modifier'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'modifier',
    },
    {
      id: '23',
      title: '備考',
      dataIndex: 'info',
      width: isBulkEdit ? remarkWidthEdit : remarkWidth,
      render: (info) => info.remarks,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (isBulkEdit) {
            setRemarkWidthEdit(size.width);
          } else {
            setRemarkWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('remarks'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'remarks',
    },
    {
      id: '24',
      title: '表示',
      dataIndex: 'info',
      width: 100,
      render: (index, item) => {
        return item.info.isUsed ? (
          <Image
            preview={false}
            width={13}
            src={checked}
            style={{ marginLeft: '3px' }}
            //   key={item['key']}
            id={item.id}
          />
        ) : (
          <></>
        );
      },
      className: 'cm-a-center',
      sorter: (a, b) => setSortNm('isUsed'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
      key: 'isUsed',
    },
    {
      id: '25',
      title: '',
      dataIndex: 'id',
      hidden: true,
    },
  ]?.filter((item) => !item.hidden);

  // テーブル幅Resizable
  const components = {
    header: {
      cell: ResizableTitle,
    },
  };

  const tableColumns = columns?.map((item) => ({
    ...item,
  }));

  const setSplitPaneSize = (splitSize) => {
    setSizes(splitSize);
  };

  /* const setShowEdtConfirmOK = (edtConfirm)=> {
    setShowEdtConfirmOKLocal(edtConfirm);
  } */

  // 係数を変更した場合、
  const onChangeCoeff = (value, clientType, isCheckZenkaku = true) => {
    if (isCheckZenkaku && regexExp.test(value)) {
      // 全角の場合、
      value = toHalfWidth(value); // 半角へ変換
    }
    if (isCheckZenkaku && value === '') value = 1;
    if (isCheckZenkaku) value = toDecimal(value, 2);
    if (clientType === ClientType.Customer) {
      setCustomerCoefficients(value);
    } else if (clientType === ClientType.Supplier) {
      setSupplierCoefficients(value);
    } else if (clientType === ClientType.Contractor) {
      setContractorCoefficients(value);
    }
  };

  // 入力項目情報
  const inputFormItem = (
    <RTable id="param_detail_tbl" className="propertiesTbl">
      <thead>
        {/* コード */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">コード</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="code"
              id="code"
              value={code}
              type="text"
              ref={(ref) => {
                inputItemRef['code'] = ref;
              }}
              maxLength={50}
              onChange={(e) => setCode(e.target.value)}
            />
          </td>
        </tr>
        {/* 枝番 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">枝番</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="branchNum"
              id="branchNum"
              value={branchNum}
              type="text"
              ref={(ref) => {
                inputItemRef['branchNum'] = ref;
              }}
              maxLength={Number.MAX_SAFE_INTEGER}
              onChange={(e) => setBranchNum(e.target.value)}
            />
          </td>
        </tr>
        {/* 名称 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">名称</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="name"
              id="name"
              value={name}
              type="text"
              ref={(ref) => {
                inputItemRef['name'] = ref;
              }}
              maxLength={150}
              onChange={(e) => setName(e.target.value)}
            />
          </td>
        </tr>
        {/* カナ */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">カナ</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="nameKana"
              id="nameKana"
              value={nameKana}
              type="text"
              ref={(ref) => {
                inputItemRef['nameKana'] = ref;
              }}
              maxLength={150}
              onChange={(e) => setNameKana(e.target.value)}
            />
          </td>
        </tr>
        {/* お客様 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">お客様/係数</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <td
                  style={{
                    width: '40px',
                    height: '44px',
                    padding: '0 7px',
                    textAlign: 'center',
                  }}
                >
                  <Checkbox
                    checked={customerFlg}
                    ref={(ref) => {
                      inputItemRef['customerFlg'] = ref;
                    }}
                    onChange={(e) => setCustomerFlg(e.target.checked)}
                  ></Checkbox>
                </td>
                <td>
                  <Input
                    placeholder={isBulkEdit ? NOT_CHANGE : ''}
                    className={'input-editable'}
                    name="customerCoefficients"
                    id="customerCoefficients"
                    value={customerCoefficients}
                    type="text"
                    ref={(ref) => {
                      inputItemRef['customerCoefficients'] = ref;
                    }}
                    maxLength={Number.MAX_SAFE_INTEGER}
                    onKeyPress={(e) => {
                      handleKeyPress(e, false);
                    }}
                    onPressEnter={(e) => onChangeCoeff(e.target.value, ClientType.Customer)}
                    onBlur={(e) => onChangeCoeff(e.target.value, ClientType.Customer)}
                    onChange={(e) => onChangeCoeff(e.target.value, ClientType.Customer, false)}
                  />
                </td>
              </tr>
            </table>
            {/* <div style={{ display: 'flex', padding: '0 5px' }}>
              <Checkbox checked={checked}></Checkbox>
              <Input
                className={'input-editable'}
                name="coefficients"
                id="coefficients"
                value={coefficients}
                type="text"
                ref={(ref) => {
                  inputItemRef['coefficients'] = ref;
                }}
                maxLength={Number.MAX_SAFE_INTEGER}
                onChange={(e) => setCoefficients(e.target.value)}
                onBlur={(e) => setCoefficients(toDecimal(e.target.value))}
              />
            </div> */}
            {/* {customerFlg ? (
              <Image
                preview={false}
                width={13}
                src={checked}
                // style={{ marginLeft: '5px' }}
                id="imgOutsourcingFg"
              />
            ) : (
              <></>
            )} */}
          </td>
        </tr>

        {/* 仕入先 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">仕入先/係数</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <td
                  style={{
                    width: '40px',
                    height: '44px',
                    padding: '0 7px',

                    textAlign: 'center',
                  }}
                >
                  <Checkbox
                    checked={supplierFlg}
                    ref={(ref) => {
                      inputItemRef['supplierFlg'] = ref;
                    }}
                    onChange={(e) => setSupplierFlg(e.target.checked)}
                  ></Checkbox>
                </td>
                <td>
                  <Input
                    placeholder={isBulkEdit ? NOT_CHANGE : ''}
                    className={'input-editable'}
                    name="supplierCoefficients"
                    id="supplierCoefficients"
                    value={supplierCoefficients}
                    type="text"
                    ref={(ref) => {
                      inputItemRef['supplierCoefficients'] = ref;
                    }}
                    maxLength={Number.MAX_SAFE_INTEGER}
                    onPressEnter={(e) => onChangeCoeff(e.target.value, ClientType.Supplier)}
                    onBlur={(e) => onChangeCoeff(e.target.value, ClientType.Supplier)}
                    onChange={(e) => onChangeCoeff(e.target.value, ClientType.Supplier, false)}
                    onKeyPress={(e) => {
                      handleKeyPress(e, false);
                    }}
                  />
                </td>
              </tr>
            </table>
            {/* {supplierFlg ? (
              <Image
                preview={false}
                width={13}
                src={checked}
                // style={{ marginLeft: '5px' }}
                id="imgOutsourcingFg"
              />
            ) : (
              <></>
            )} */}
          </td>
        </tr>

        {/* 委託先 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">委託先/係数</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <table style={{ width: '100%' }}>
              <tr>
                <td
                  style={{
                    width: '40px',
                    height: '44px',
                    padding: '0 7px',

                    textAlign: 'center',
                  }}
                >
                  <Checkbox
                    checked={contractorFlg}
                    ref={(ref) => {
                      inputItemRef['contractorFlg'] = ref;
                    }}
                    onChange={(e) => setContractorFlg(e.target.checked)}
                  ></Checkbox>
                </td>
                <td>
                  <Input
                    placeholder={isBulkEdit ? NOT_CHANGE : ''}
                    className={'input-editable'}
                    name="contractorCoefficients"
                    id="contractorCoefficients"
                    value={contractorCoefficients}
                    type="text"
                    ref={(ref) => {
                      inputItemRef['contractorCoefficients'] = ref;
                    }}
                    maxLength={Number.MAX_SAFE_INTEGER}
                    onPressEnter={(e) => onChangeCoeff(e.target.value, ClientType.Contractor)}
                    onBlur={(e) => onChangeCoeff(e.target.value, ClientType.Contractor)}
                    onChange={(e) => onChangeCoeff(e.target.value, ClientType.Contractor, false)}
                    onKeyPress={(e) => {
                      handleKeyPress(e, false);
                    }}
                  />
                </td>
              </tr>
            </table>
            {/* {contractorFlg ? (
              <Image
                preview={false}
                width={13}
                src={checked}
                // style={{ marginLeft: '5px' }}
                id="imgOutsourcingFg"
              />
            ) : (
              <></>
            )} */}
          </td>
        </tr>

        {/* Tel */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">Tel</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="tel"
              id="tel"
              value={tel}
              type="text"
              ref={(ref) => {
                inputItemRef['tel'] = ref;
              }}
              maxLength={20}
              onChange={(e) => setTel(e.target.value)}
            />
          </td>
        </tr>
        {/* Fax */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">Fax</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="fax"
              id="fax"
              value={fax}
              type="text"
              ref={(ref) => {
                inputItemRef['fax'] = ref;
              }}
              maxLength={20}
              onChange={(e) => setFax(e.target.value)}
            />
          </td>
        </tr>
        {/* 担当者 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">担当者</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="contactParson"
              id="contactParson"
              value={contactParson}
              type="text"
              ref={(ref) => {
                inputItemRef['contactParson'] = ref;
              }}
              maxLength={50}
              onChange={(e) => setContactParson(e.target.value)}
            />
          </td>
        </tr>
        {/* メール */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">メール</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="mail"
              id="mail"
              value={mail}
              type="text"
              ref={(ref) => {
                inputItemRef['mail'] = ref;
              }}
              maxLength={100}
              onChange={(e) => setMail(e.target.value)}
            />
          </td>
        </tr>
        {/* 郵便番号 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">郵便番号</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="zip"
              id="zip"
              value={zip}
              type="text"
              ref={(ref) => {
                inputItemRef['zip'] = ref;
              }}
              maxLength={10}
              onChange={(e) => setZip(e.target.value)}
            />
          </td>
        </tr>
        {/* 都道府県 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">都道府県</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="prefecture"
              id="prefecture"
              value={prefecture}
              type="text"
              ref={(ref) => {
                inputItemRef['prefecture'] = ref;
              }}
              maxLength={10}
              onChange={(e) => setPrefecture(e.target.value)}
            />
          </td>
        </tr>
        {/* 住所 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">住所</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="address"
              id="address"
              value={address}
              type="text"
              ref={(ref) => {
                inputItemRef['address'] = ref;
              }}
              maxLength={250}
              onChange={(e) => setAddress(e.target.value)}
            />
          </td>
        </tr>
        {/* ソート番号 */}
        {/* <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">ソート番号</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              className={'input-editable'}
              name="sortNum"
              id="sortNum"
              value={sortNum}
              type="text"
              ref={(ref) => {
                inputItemRef['sortNum'] = ref;
              }}
              maxLength={Number.MAX_SAFE_INTEGER}
              onChange={(e) => setSortNum(e.target.value)}
            />
          </td>
        </tr> */}
        {/* 作成日 */}
        {/* 更新日 */}
        {/* 更新者 */}
        {isBulkEdit ? (
          ''
        ) : (
          <>
            <tr className="detail-tbl-row">
              <td className="param-detail-tbl-val-title">
                <label className="param_detail-title-label">作成日</label>
              </td>
              <td style={{ verticalAlign: 'middle' }}>
                <label className="param_detail-title-label">{created}</label>
              </td>
            </tr>
            <tr className="detail-tbl-row">
              <td className="param-detail-tbl-val-title">
                <label className="param_detail-title-label">更新日</label>
              </td>
              <td style={{ verticalAlign: 'middle' }}>
                <label className="param_detail-title-label">{modified}</label>
              </td>
            </tr>
            <tr className="detail-tbl-row">
              <td className="param-detail-tbl-val-title">
                <label className="param_detail-title-label">更新者</label>
              </td>
              <td style={{ verticalAlign: 'middle' }}>
                <label className="param_detail-title-label">{modifier}</label>
              </td>
            </tr>
          </>
        )}

        {/* 備考 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">備考</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <TextArea
              placeholder={isBulkEdit ? NOT_CHANGE : ''}
              className={'input-editable'}
              name="remarks"
              id="remarks"
              value={remarks}
              type="text"
              maxLength={2048}
              style={{ margin: 5, padding: 5, width: '98.3%' }}
              onChange={(e) => setRemarks(e.target.value)}
            />
          </td>
        </tr>

        {/* 表示 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">表示</label>
          </td>
          {isBulkEdit ? (
            <td style={{ verticalAlign: 'middle' }}>
              <RadioGroup
                name="isUsedEdit"
                defaultValue={0}
                className="radioCustomerGpEdit"
                onChange={(e) => setIsUsedEdit(e.target.value)}
                value={isUsedEdit}
              >
                <Radio value={0}>{NOT_CHANGE}</Radio>
                <Radio value={1}>オン</Radio>
                <Radio value={2}>オフ</Radio>
              </RadioGroup>
            </td>
          ) : (
            <td style={{ verticalAlign: 'middle' }}>
              <RadioGroup
                name="isUsed"
                defaultValue={1}
                className="radioCustomerGpEdit"
                onChange={(e) => setIsUsed(e.target.value)}
                value={isUsed}
              >
                <Radio value={true}>オン</Radio>
                <Radio value={false}>オフ</Radio>
              </RadioGroup>
            </td>
          )}
        </tr>
      </thead>
    </RTable>
  );

  const getPartName = (partName = activePartMenu) => {
    return partName === partType[0] ? 'お客様' : '仕入先';
  };

  const getSelectedRowId = (partName = activePartMenu) => {
    return partName === partType[0] ? cusSelectedRowId : supSelectedRowId;
  };

  const setSelectedRowId = (value, partName = activePartMenu) => {
    partName === partType[0] ? setCusSelectedRowId(value) : setSupSelectedRowId(value);
  };

  const getCurrentData = (partName = activePartMenu) => {
    return partName === partType[0] ? [...customersData] : [...supplierData];
  };

  const setCurrentData = (value, partName = activePartMenu) => {
    partName === partType[0] ? setCustomersData(value) : setSupplierData(value);
  };

  const getCurrentPage = (partName = activePartMenu) => {
    return partName === partType[0] ? cusCurrentPage : supCurrentPage;
  };

  // const setCurrentPage = (value, partName = activePartMenu) => {
  //   partName === partType[0] ? setCusCurrentPage(value) : setSupCurrentPage(value);
  // };

  const setCurrentPage = (value) => {
    setCusCurrentPage(value);
  };

  // 選択中行のデータを取得する
  const getSelectedData = (data, id) => {
    let ret = [];
    let record;
    record = data?.find((item) => item.id === id);
    return record ? record : ret;
  };

  // 最大ソート番号を得る
  const getMaxSortNum = () => {
    let sortedList = getCurrentData().sort((a, b) => b.info.sortNum - a.info.sortNum);
    return sortedList?.length > 0 ? sortedList[0].info.sortNum + 1 : 1;
  };

  // Idで降順する
  // const descOrderById = (data) => {
  //   let sortedList = data.sort((a, b) => b.id - a.id);
  //   return sortedList;
  // };

  // 一覧画面の行を選択した場合、
  const onRowSelect = (record) => {
    let selectedCustomersData = [];
    if (record !== undefined) {
      selectedCustomersData.push({
        id: record.id,
        code: record.code,
        name: record.name,
        clientType: record.clientType,
        coeffClients: record.coeffClients,
        info: record.info,
        created: record.created,
        modified: record.modified,
        modifier: record.modifier,
      });
      setChangeRecordId(record.id);
      if (editMode) {
        setDiscardChangeMode(discardChange[0]);
        let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
        setEditModeCancelConfirm(moveInEdit);
        if (!moveInEdit) {
          setSelectedRowId(record.id);
          setSelectedData(selectedCustomersData[0]);
          navigate(':common.customer');
        }
      } else {
        setSelectedRowId(record.id);
        setSelectedData(selectedCustomersData[0]);
        navigate(':common.customer');
      }
      props?.updateSelectedRowId(record?.id, 0, cusCurrentPage, ascSortFlg, sortNm, filterDatas);
      props?.resetInitialParam();
    } else {
      setSelectedRowId(-1);
      setSelectedData([]);
      navigate(':common.customer');
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setTblLoading(true); // Waitingダイアログを表示にする
    let pageBefore = pagination?.current - 1;
    let ascSortFlg = 'ASC';
    if (sorter?.order === undefined) {
      ascSortFlg = '';
    } else if (sorter?.order === 'ascend') {
      ascSortFlg = 'ASC';
    } else if (sorter?.order === 'descend') {
      ascSortFlg = 'DESC';
    }
    setAscSortFlg(ascSortFlg);
    let clientInfos = await getClientInfo(pagination?.pageSize, pageBefore, ascSortFlg, sorter?.columnKey, filterDatas);
    if (clientInfos) {
      let clientsData = clientInfos ? clientInfos?.data : [];
      setFilteredData(clientsData);
    }
    setTblLoading(false); // Waitingダイアログを表示にする
  };

  const onRowSelectWithoutEditMode = (record) => {
    let selectedCustomersData = [];
    if (record !== undefined) {
      selectedCustomersData.push({
        id: record.id,
        code: record.code,
        name: record.name,
        clientType: record.clientType,
        coeffClients: record.coeffClients,
        info: record.info,
        created: record.created,
        modified: record.modified,
        modifier: record.modifier,
      });
      setChangeRecordId(record.id);
      setSelectedRowId(record.id);
      setSelectedData(selectedCustomersData[0]);
      const customerLst = [...filteredData];
      if (customerLst?.length > 0) {
        setCusCurrentPage(Math.ceil(customerLst?.length / 25));
      } else {
        setCusCurrentPage(1);
      }
      props?.updateSelectedRowId(record?.id, 0, cusCurrentPage, ascSortFlg, sortNm, filterDatas);
      navigate(':common.customer');
    } else {
      setSelectedRowId(-1);
      setSelectedData([]);
      navigate(':common.customer');
    }
  };

  const handleOkCSVInput = (e) => {
    setVisibleCSVInput(false);
    let input = document.createElement('input');
    input.type = 'file';
    input.accept = '.csv';
    input.onchange = (_) => {
      let files = Array.from(input.files);
    };
    input.click();
  };

  const handleOkXMLInput = (e) => {
    setVisibleXMLInput(false);
    let input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xml';
    input.onchange = (_) => {
      let files = Array.from(input.files);
    };
    input.click();
  };

  // 削除ボタンを押下
  const deleteProcess = () => {
    let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
    // setEditModeCancelConfirm(moveInEdit);
    if (!moveInEdit) {
      setIsDelete(false);
      deleteOk();
    } else {
      setIsDelete(true);
    }
  };

  const deleteAllProcess = () => {
    let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
    // setEditModeCancelConfirm(moveInEdit);
    if (!moveInEdit) {
      setIsDeleteAll(false);
      deleteAllRecord();
    } else {
      setIsDeleteAll(true);
    }
  };

  const deleteAllCancel = () => {
    setIsDeleteAll(false);
  };

  const deleteAllRecord = async () => {
    let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;

    if (isDeleteAll || !moveInEdit) {
      props?.loading(true); // Waitingダイアログを表示にする
      setIsDeleteAll(false);
      setEditMode(false);
      let deletedData = await deleteAllClientData();
      // IQX_WEBEST-281 使用しているパラメータなのに削除出来てしまう
      if (deletedData) {
        setFilteredData([]);

        getClientData();
      }
      props?.loading(false); // Waitingダイアログを非表示にする
    }
  };

  // 2025-10-08 IQX_WEBEST-486 複数削除ができてほしい
  // 一括削除のため、選択する
  const deleteRowSelection = {
    selectedRowKeys: deleteSelectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setDeleteSelectedRowKeys(newSelectedRowKeys);
    },
  };

  // 一括削除のため、全て選択する
  const handleSelectAll = () => {
    const allIds = filteredData.map((item) => item?.id);
    setDeleteSelectedRowKeys(allIds);
  };

  // 一括削除ボタンを押下
  const bulkDeleteProcess = () => {
    let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
    // setEditModeCancelConfirm(moveInEdit);
    if (!moveInEdit) {
      setIsBulkDelete(false);
      bulkDeleteOk();
    } else {
      setIsBulkDelete(true);
    }
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  async function bulkDeleteClientData(ids) {
    let ret = null;
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'Client/bulk-delete';
      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify(ids),
      };

      const response = await fetch(Url, otherParam);
      const data = await response.json();

      if (data?.updateToken) {
        updateAccessToken(data.updateToken);
      }

      if (data && data.statusCode === StatusCodes.OK) {
        ret = data;
      } else if (data && (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)) {
        authorizeError(ErrorMessage()[data?.messageCode]);
      } else if (data && data.statusCode !== StatusCodes.OK) {
        error(ErrorMessage()[data?.messageCode]);
      }
    } catch (e) {
      error(e.message);
    }
    return ret;
  }

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const bulkDeleteOk = async () => {
    if (!deleteSelectedRowKeys.length) {
      message.warning('削除する項目を選択してください。');
      return;
    }

    props?.loading(true);
    setBulkDeleteLoading(true);
    try {
      const deletedData = await bulkDeleteClientData(deleteSelectedRowKeys);
      if (deletedData && deletedData.statusCode === StatusCodes.OK) {
        complete(`${deleteSelectedRowKeys.length} 件のデータを削除しました`);

        // Remove deleted items from UI
        let filterdData = [...filteredData].filter((item) => !deleteSelectedRowKeys.includes(item.id));
        setFilteredData(filterdData);

        let currentData = [...getCurrentData()].filter((item) => !deleteSelectedRowKeys.includes(item.id));
        setCurrentData(currentData);
        setTmpFilteredData(currentData);

        setDeleteSelectedRowKeys([]);
        setTotalCount(totalCount - deleteSelectedRowKeys.length);
      } else {
        error('削除に失敗しました');
      }
    } catch (e) {
      error('削除に失敗しました: ' + e.message);
    } finally {
      props?.loading(false);
      setBulkDeleteLoading(false);
    }
  };

  // 削除確認ポップアップのOKボタンを押下
  const deleteOk = async (e) => {
    let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;

    if (isDelete || !moveInEdit) {
      props?.loading(true); // Waitingダイアログを表示にする
      setIsDelete(false);
      setEditMode(false);
      let selectedId = getSelectedRowId();
      let deletedData = await deleteClientData(selectedId);
      // IQX_WEBEST-281 使用しているパラメータなのに削除出来てしまう
      if (deletedData !== undefined && deletedData?.id > 0) {
        let filterdData = [...filteredData];
        filterdData = filterdData?.filter((item) => item.id !== deletedData.id);

        setFilteredData(filterdData);

        let currentData = getCurrentData();
        currentData = currentData?.filter((item) => item.id !== deletedData.id);

        onRowSelectWithoutEditMode(currentData !== undefined && currentData?.length > 0 ? currentData?.[0] : []);
        // setCurrentPage(1);
        setCurrentData(currentData);
        setTmpFilteredData(currentData);
        getClientData();
        let deleteAfterTotalCnt = totalCount < 1 ? 0 : totalCount - 1;
        setTotalCount(deleteAfterTotalCnt);
      }
      props?.loading(false); // Waitingダイアログを非表示にする
    }
  };

  // 取引先情報をDBに削除する
  async function deleteClientData(id) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'Client/' + id;
      const otherParam = {
        method: 'DELETE',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  async function deleteAllClientData() {
    let ret = false;
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'Client/delete-all';
      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = true;
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  // 削除確認ポップアップのCandelボタンを押下
  const deleteCancel = (e) => {
    setIsDelete(false);
  };

  const bulkDeleteCancel = (e) => {
    setIsBulkDelete(false);
    setDeleteSelectedRowKeys([]);
  };

  const showCSVInputModal = () => {
    setVisibleCSVInput(true);
    setChildTitle('CSV入力');
  };

  const showXMLInputModal = () => {
    setVisibleXMLInput(true);
    setChildTitle('XML入力');
  };

  const resetInputInfo = async (insert = false) => {
    if (insert) {
      const maxCode = await getMaxCode('GetClientMaxCode', 'Client');
      const nextCode = `CUS-${(maxCode + 1).toString().padStart(4, '0')}`;
      setCode(nextCode);
    } else {
      setCode('');
    }

    setName('');
    setCustomerFlg(false);
    setSupplierFlg(false);
    setContractorFlg(false);
    setCustomerCoefficients('');
    setSupplierCoefficients('');
    setContractorCoefficients('');
    setIsUsed();
    setBranchNum();
    setNameKana('');
    setTel('');
    setFax('');
    setContactParson('');
    setMail('');
    setZip('');
    setPrefecture('');
    setAddress('');
    setRemarks('');
    setSortNum();
    setCreated(today);
    setModified(today);
    setModifier('');
    setIsUsedEdit(0);
  };

  // 表示で検索する場合、
  const searchByDataState = (value) => {
    dataState === value ? getDataByFilter() : setDataState(value);
    setIsFilterFlg(true);
  };

  // お客様で検索する場合、
  const searchByCustomerFlg = (value) => {
    customerFlgState === value ? getDataByFilter() : setCustomerFlgState(value);
    setIsFilterFlg(true);
  };

  // 仕入先で検索する場合、
  const searchBySupplierFlg = (value) => {
    supplierFlgState === value ? getDataByFilter() : setSupplierFlgState(value);
    setIsFilterFlg(true);
  };

  // 委託先で検索する場合、
  const searchByContractorFlg = (value) => {
    contractorFlgState === value ? getDataByFilter() : setContractorFlgState(value);
    setIsFilterFlg(true);
  };

  // キーワードで検索する場合、
  const searchByKeyword = (e) => {
    keyword === e.target.value ? getDataByFilter() : setKeyWord(e.target.value);
    setIsFilterFlg(true);
  };

  // 一覧データをキーワードで絞り込む
  const getDataByFilter = async (partName = activePartMenu) => {
    let currentData = getCurrentData(partName);
    if (currentData?.length <= 0) {
      return;
    }
    let searchBarText = keyword;
    let flag;
    let currentFilterData = currentData;

    // // キーワードで絞り込み
    // if (searchBarText != '') {
    //   currentFilterData = currentFilterData?.filter(
    //     (item) =>
    //       item.code?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.name?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.coeffClients?.map((i) => i.coeff.toString().indexOf(searchBarText)) >= 0 ||
    //       item.info.branchNum?.toString().indexOf(searchBarText) >= 0 ||
    //       item.info.nameKana?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.info.tel?.toString().indexOf(searchBarText) >= 0 ||
    //       item.info.fax?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.info.contactParson?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.info.mail?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.info.zip?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.info.prefecture?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.info.address?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.info.remarks?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.info.sortNum?.toString().indexOf(searchBarText) >= 0 ||
    //       item.created?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.modified?.toLowerCase().indexOf(searchBarText) >= 0 ||
    //       item.modifier?.toLowerCase().indexOf(searchBarText) >= 0
    //   );
    // }

    // // //  表示で絞り込み
    // if (dataState === 1 || dataState === 2) {
    //   dataState === 1 ? (flag = true) : (flag = false);
    //   currentFilterData = currentFilterData?.filter((item) => item.info.isUsed === flag);
    // }

    // //  お客様で絞り込み
    // if (customerFlgState === 1 || customerFlgState === 2) {
    //   currentFilterData =
    //     customerFlgState === 1
    //       ? currentFilterData?.filter((item) => isCustomer(item.clientType))
    //       : currentFilterData?.filter((item) => !isCustomer(item.clientType));
    // }

    // //  仕入先で絞り込み
    // if (supplierFlgState === 1 || supplierFlgState === 2) {
    //   currentFilterData =
    //     supplierFlgState === 1
    //       ? currentFilterData?.filter((item) => isSupplier(item.clientType))
    //       : currentFilterData?.filter((item) => !isSupplier(item.clientType));
    // }

    // //  委託先で絞り込み
    // if (contractorFlgState === 1 || contractorFlgState === 2) {
    //   currentFilterData =
    //     contractorFlgState === 1
    //       ? currentFilterData?.filter((item) => isContractor(item.clientType))
    //       : currentFilterData?.filter((item) => !isContractor(item.clientType));
    // }

    let filterData = {
      customerFlgState: customerFlgState,
      supplierFlgState: supplierFlgState,
      contractorFlgState: contractorFlgState,
      keyword: searchBarText,
      isUsedFlg: dataState,
    };
    setFilterDatas(filterData);
    let clientInfos = await getClientInfo(pageSize, 0, ascSortFlg, sortNm, filterData);
    if (clientInfos) {
      currentFilterData = clientInfos ? clientInfos?.data : [];
      setTotalCount(clientInfos?.totalCount);
    }

    /* let selectedRowId = getSelectedRowId(partName);
    let index = currentFilterData?.findIndex((item) => item.id === selectedRowId);
    // 検索した結果に、選択中行のIdが無い場合、
    if (index === -1) {
      // 編集中である場合、
      if (editMode) {
        setDiscardChangeMode(discardChange[1]);
        setEditModeCancelConfirm(true);
        return;
      }
      // 検索結果がある場合、
      if (currentFilterData?.length > 0) {
        index = 0;
        let idVal = currentFilterData[index]?.id;
        setSelectedRowId(idVal, partName);
      }
    }
    currentFilterData?.length > 0
      ? setSelectedData(currentFilterData[index]) // 検索結果がある場合、
      : setSelectedData(currentFilterData); // 検索結果が無い場合、
    // 一覧に表示するデータ */
    setFilteredData(currentFilterData);
    setCusCurrentPage(1);
    setIsFilterFlg(false);
    let currentRow = getSelectedRowId();
    props?.updateSelectedRowId(currentRow, 0, cusCurrentPage, ascSortFlg, sortNm, filterData);
  };

  const reportModalTitle = (
    <div
      style={{
        width: 520,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>確認</p>
    </div>
  );

  const editModalTitle = (
    <div
      style={{
        width: 1300,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  const addNewModalTitle = (
    <div
      style={{
        width: 700,
        backgroundColor: '#005fab',
        marginLeft: -10,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  // 確認ポップアップのOKボタン押下
  const confirmOk = async (e) => {
    if (isCreateNew) {
      setCreateConfirm(false);
      // 画面の入力チェック
      if (!(await detailRef.current.formValidation(inputItemRef, formValidatorMode.Create))) {
        return;
      }
      props?.loading(true); // Waitingダイアログを表示にする
      let lastIndex = tempCustomersData?.length - 1;
      let tempData = tempCustomersData[lastIndex];
      let createdData = await createClientData(tempData);
      setCurrentData((prevData) => [...prevData, createdData]);
      setTmpFilteredData(createdData);
      setFilteredData((filteredData) => [...filteredData, createdData]);
      onRowSelectWithoutEditMode(createdData);
      setIsCreateNew(false);
      // setCusCurrentPage(1);
      setSelectedRowId(createdData?.id);
      setSelectedData(createdData);
      props?.updateSelectedRowId(createdData?.id, 0, 1, ascSortFlg, sortNm, filterDatas);
      setIsFilterFlg(true);
      props?.loading(false); // Waitingダイアログを非表示にする
    } else if (isBulkEdit) {
      setUpdateConfirm(false);
      // 画面の入力チェック
      if (!(await detailRef.current.formValidation(inputItemRef, formValidatorMode.BulkEdit))) {
        return;
      }
      // 一括編集画面から遷移された場合、
      setIsBulkEdit(false);
      props?.loading(true); // Waitingダイアログを表示にする
      // 選択された全ての対象行を更新
      for (let i = 0; i < bulkEditSelectedRow?.length; i++) {
        let item = bulkEditSelectedRow[i];
        let clientType = 0;
        if (name) item.name = name;
        if (code) item.code = code;
        if (customerFlg === true || isCustomer(item.clientType)) {
          clientType = ClientType.Customer;
        }
        if (customerFlg === true) {
          let index = item.coeffClients?.findIndex((record) => record.clientType === ClientType.Customer);
          if (index !== -1) {
            item.coeffClients[index].coeff = customerCoefficients;
          } else {
            item.coeffClients.push({
              clientType: ClientType.Customer,
              coeff: customerCoefficients ? parseFloat(customerCoefficients) : 0.0,
            });
          }
        }
        if (supplierFlg === true || isSupplier(item.clientType)) {
          clientType = clientType + ClientType.Supplier;
        }
        if (supplierFlg === true) {
          let index = item.coeffClients?.findIndex((record) => record.clientType === ClientType.Supplier);
          if (index !== -1) {
            item.coeffClients[index].coeff = supplierCoefficients;
          } else {
            item.coeffClients.push({
              clientType: ClientType.Supplier,
              coeff: supplierCoefficients ? parseFloat(supplierCoefficients) : 0.0,
            });
          }
        }
        if (contractorFlg === true || isContractor(item.clientType)) {
          clientType = clientType + ClientType.Contractor;
        }
        if (contractorFlg === true) {
          let index = item.coeffClients?.findIndex((record) => record.clientType === ClientType.Contractor);
          if (index !== -1) {
            item.coeffClients[index].coeff = contractorCoefficients;
          } else {
            item.coeffClients.push({
              clientType: ClientType.Contractor,
              coeff: contractorCoefficients ? parseFloat(contractorCoefficients) : 0.0,
            });
          }
        }
        if (clientType !== 0) item.clientType = clientType;
        if (isUsedEdit > 0) {
          item.info.isUsed = isUsedEdit === 1 ? true : false;
        }
        if (branchNum) item.info.branchNum = branchNum;
        if (nameKana) item.info.nameKana = nameKana;
        if (tel) item.info.tel = tel;
        if (fax) item.info.fax = fax;
        if (contactParson) item.info.contactParson = contactParson;
        if (mail) item.info.mail = mail;
        if (zip) item.info.zip = zip;
        if (prefecture) item.info.prefecture = prefecture;
        if (address) item.info.address = address;
        if (remarks) item.info.remarks = remarks;
        if (sortNum) item.info.sortNum = sortNum;
        item.modified = today;
        await submitData(item);
      }
      setIsFilterFlg(true);
      props?.loading(false); // Waitingダイアログを非表示にする
    }
    resetInputInfo();
  };

  // 取引先情報をDBに新規登録する
  async function createClientData(createData) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'Client';
      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          code: createData.code,
          name: createData.name,
          clientType: createData.clientType,
          coeffClients: createData.coeffClients,
          info: createData.info,
        }),
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  // 確認ポップアップのCancelボタン押下
  const confirmCancel = () => {
    setUpdateConfirm(false);
    setCreateConfirm(false);
  };

  // 編集中破壊確認ポップアップのOKボタン押下
  const discardConfirmOk = () => {
    setEditModeCancelConfirm(false);
    detailRef.current.discardConfirmOk();
  };

  // 編集中破壊確認ポップアップのCancelボタン押下
  const discardConfirmCancel = () => {
    /* setEditModeCancelConfirm(showEdtConfirmCancle);
    if (!showEdtConfirmCancle) {
      detailRef.current.discardConfirmCancel();
    } */
    setEditModeCancelConfirm(false);
    detailRef.current.discardConfirmCancel();
  };

  // 破壊確認ポップアップのOKボタン押下
  const cancelConfirmOK = () => {
    if (isCreateNew) {
      setIsCreateNew(false);
    } else if (isBulkEdit) {
      setIsBulkEdit(false);
    }
    setCancelConfirm(false);
  };

  // 破壊確認ポップアップのCancelボタン押下
  const cancelConfirmCancel = () => {
    setCancelConfirm(false);
  };

  // お客様・仕入先タブの切り替え
  const partMenuChange = (e) => {
    setChangePartName(e.target.value);
    if (editMode) {
      setDiscardChangeMode(discardChangePart[0]);
      setEditModeCancelConfirm(true);
      return;
    }
    if (keyword != '' || dataState != 0 || customerFlgState != 0 || supplierFlgState != 0 || contractorFlgState != 0) {
      getDataByFilter(e.target.value);
    } else {
      var currentData = getCurrentData(e.target.value);
      var rowId = getSelectedRowId(e.target.value);
      var selectedData = getSelectedData(currentData, rowId);
      setSelectedData(selectedData);
      setFilteredData(currentData);
    }
    //setActivePartMenu(e.target.value);
  };

  // 更新確認のOKを押下で、一覧画面のデータを反映する
  const submitData = async (updateData) => {
    var tmpData = [];
    var updatedInfo = [];
    var index;
    let selectedRowId = getSelectedRowId();
    props?.loading(true); // Waitingダイアログを表示にする
    updatedInfo = await updateClientData(updateData);
    tmpData = getCurrentData();
    index = tmpData?.findIndex((item) => item.id === updatedInfo.id);
    tmpData[index] = updatedInfo;
    setCurrentData(tmpData);
    setTmpFilteredData(tmpData);

    tmpData = [...filteredData];
    index = tmpData?.findIndex((item) => item.id === updatedInfo.id);
    tmpData[index] = updatedInfo;
    setFilteredData(tmpData);

    // 詳細情報を再表示
    if (updatedInfo.id === selectedRowId) detailRef.current?.displayDetailInfo(updatedInfo);
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  // 取引先情報をDBに更新する
  async function updateClientData(updateData) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'Client';
      const otherParam = {
        method: 'PUT',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          id: updateData.id,
          code: updateData.code,
          name: updateData.name,
          clientType: updateData.clientType,
          coeffClients: updateData.coeffClients,
          info: updateData.info,
        }),
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  // 編集モードを変更
  const updateEditMode = (mode) => {
    setEditMode(mode);
    props.updateMainParameterEditMode(mode);
  };

  // 新規作成-開始
  const createNewProcess = () => {
    resetInputInfo(true);
    setIsCreateNew(true);
    setIsUsed(true);
    setCustomerFlg(true);
    setSupplierFlg(true);
    setContractorFlg(true);
    setCustomerCoefficients((1).toFixed(2));
    setSupplierCoefficients((1).toFixed(2));
    setContractorCoefficients((1).toFixed(2));
    setSortNum(getMaxSortNum());
    setChildTitle(getPartName() + '（新規作成）');
  };

  const createNewOK = () => {
    prepareCreateNewInfo();
  };

  const createNewCancel = (e) => {
    //setCancelConfirm(true);
    setCancelConfirm(showEdtConfirmCancle);
    if (!showEdtConfirmCancle && isCreateNew) {
      setIsCreateNew(false);
    }
  };

  // 入力した新規情報を取得する
  const prepareCreateNewInfo = (e) => {
    let tempCustomersData = [];
    const updatedBranch = branchNum
      ? typeof branchNum === 'string'
        ? branchNum?.trim() === ''
          ? 0
          : branchNum?.replace(/ /g, '')
        : branchNum
      : 0;
    let info = {
      isUsed: isUsed,
      branchNum: updatedBranch,
      nameKana: nameKana,
      tel: tel,
      fax: fax,
      contactParson: contactParson,
      mail: mail,
      zip: zip,
      prefecture: prefecture,
      address: address,
      remarks: remarks,
      sortNum: sortNum,
    };
    let clientType = 0;
    let coeffs = [];
    if (customerFlg === true) {
      clientType = ClientType.Customer;
      coeffs.push({
        clientType: ClientType.Customer,
        coeff: customerCoefficients ? parseFloat(customerCoefficients) : 0.0,
      });
    }
    if (supplierFlg === true) {
      clientType = clientType + ClientType.Supplier;
      coeffs.push({
        clientType: ClientType.Supplier,
        coeff: supplierCoefficients ? parseFloat(supplierCoefficients) : 0.0,
      });
    }
    if (contractorFlg === true) {
      clientType = clientType + ClientType.Contractor;
      coeffs.push({
        clientType: ClientType.Contractor,
        coeff: contractorCoefficients ? parseFloat(contractorCoefficients) : 0.0,
      });
    }
    tempCustomersData.push({
      code: code,
      name: name,
      clientType: clientType,
      coeffClients: coeffs,
      info: info,
      created: today,
      modified: today,
    });
    setTempCustomersData(tempCustomersData);
    setCreateConfirm(true);
  };

  const createNewTitle = (
    <div
      style={{
        width: 800,
        backgroundColor: '#005fab',
        marginLeft: -10,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  const createNewContent = (
    <>
      <Row style={{ paddingBottom: 0, paddingTop: 0, marginBottom: '10px' }}>
        {/** プロパティレイアウト */}
        <Col span={24}>
          <div
            style={{
              height: 750,
              // marginTop: 28,
              fontSize: '13.5px',
              overflowY: 'auto',
              whiteSpace: 'nowrap',
            }}
          >
            {inputFormItem}
          </div>
        </Col>
      </Row>
      <Row
        justify="end"
        style={{
          marginBottom: 0,
          marginTop: 0,
        }}
      >
        <Button className="mainButton" onClick={createNewOK} style={{ marginRight: 5 }}>
          登録
        </Button>
        <Button className="cancelButton" onClick={createNewCancel}>
          {/* 2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
              編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
              破棄の表記ではなく「戻る」や「終了」にするのはどうか */}
          {/* 破棄 */}
          戻る
        </Button>
      </Row>
    </>
  );
  // 新規作成-終了

  // 一括編集-開始
  const onRowCheckboxSelect = (checked, record) => {
    checkedRow = [...checked];
    setBulkEditSelectedRow([...record]);
    setBulkEditSelectedRowId(checkedRow);
    setChkRowsCount(checkedRow?.length);
    navigate(':common.customer');
  };

  const bulkEditRowSelect = {
    onChange: onRowCheckboxSelect,
  };

  const bulkEditProcess = () => {
    resetInputInfo();
    setBulkEditSelectedRow([]);
    setBulkEditSelectedRowId([]);
    setChkRowsCount(0);
    setIsBulkEdit(true);
    setChildTitle(getPartName() + '（選択したデータをまとめて編集）');
  };

  const bulkEditOK = (e) => {
    setUpdateConfirm(true);
  };

  const bulkEditCancel = (e) => {
    setCancelConfirm(true);
  };

  const bulkEditTitle = (
    <div
      style={{
        width: 1790,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  const handlePageSizeChangeEdit = (current, pagesize) => {
    setEditPageSize(pagesize);
  };

  const bulkEditContent = (
    <>
      <Row style={{ paddingBottom: 0, paddingTop: 0 }}>
        {/** 一覧 */}
        <Col span={13}>
          <p style={{ fontSize: '13.5px', marginBottom: 6, marginTop: 0, fontWeight: '700' }}>
            {chkrowscount}件を選択中
          </p>
          <Table
            showSorterTooltip={false}
            components={components}
            columns={tableColumns}
            rowKey={(record) => record.id}
            dataSource={filteredData}
            scroll={{ y: 250, x: '10vw' }}
            rowClassName={(record) => (record.id == bulkEditSelectedRowId ? 'active-row' : 'data-row')}
            className="parent-detail-EditTable"
            rowSelection={bulkEditRowSelect}
            pagination={{
              position: ['bottomLeft'],
              total: totalCount,
              showTotal: (total, range) => `全${total}件中${range[0]}件〜${range[1]}件を表示`,
              defaultCurrent: 1,
              pageSize: editPageSize,
              pageSizeOptions: pageSizes,
              current: editPage,
              showSizeChanger: true,
              onShowSizeChange: handlePageSizeChangeEdit,
              onChange: (page) => {
                setEditPage(page);
              },
            }}
            onChange={handleTableChange}
            loading={tblLoading}
          />
        </Col>
        {/** プロパティレイアウト */}
        <Col span={11}>
          <div
            style={{
              height: 749,
              marginTop: 28,
              fontSize: '13.5px',
              overflowY: 'auto',
              whiteSpace: 'nowrap',
            }}
          >
            {inputFormItem}
          </div>
        </Col>
      </Row>
      <Row
        justify="end"
        style={{
          marginBottom: 0,
          marginTop: -40,
        }}
      >
        <Button className="mainButton" onClick={bulkEditOK} style={{ marginRight: 5 }}>
          更新
        </Button>
        <Button className="cancelButton" onClick={bulkEditCancel}>
          {/* 2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
              編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
              破棄の表記ではなく「戻る」や「終了」にするのはどうか */}
          {/* 破棄 */}
          戻る
        </Button>
      </Row>
    </>
  );
  // 一括編集-終了

  // 検索条件をクリアボタン
  const filterClearBtn = (
    <>
      <div style={{ display: 'flex' }}>
        <Image preview={false} width={18} height={18} src={filter_clear_icon} style={{ marginBottom: '5px' }} />
        <label style={{ marginLeft: '5px', marginTop: 1, fontSize: '12px' }}>検索条件をクリア</label>
      </div>
    </>
  );

  // 検索条件を初期値にする
  const clearAllFilter = (e) => {
    setDataState(0);
    setCustomerFlgState(0);
    setSupplierFlgState(0);
    setContractorFlgState(0);
    setKeyWord('');
    setIsFilterFlg(true);
  };

  const handlePageSizeChange = (current, pagesize) => {
    setPageSize(pagesize);
  };

  // CSVヘッダの情報
  const getCSVHeaderInfo = () => {
    let str = '';
    columns?.map((col) => (str.length === 0 ? (str += col.title) : (str += ',' + col.title))); // ヘッダの情報
    str = 'ID,' + str;
    return str;
  };

  // CSV出力情報
  const getCsvExportData = async () => {
    let str = '';
    str = getCSVHeaderInfo();
    let pageBefore =
      props.initialParam === 'customer' && props?.rowSelectPage !== undefined && props?.rowSelectPage !== 0
        ? props?.rowSelectPage - 1
        : 0;
    let propSortFlg =
      props.initialParam === 'customer' && props?.ascSortFlg !== undefined ? props?.ascSortFlg : ascSortFlg;
    let propSortNm = props.initialParam === 'customer' && props?.sortNm !== undefined ? props?.sortNm : sortNm;
    let propFilterDatas =
      props.initialParam === 'customer' && props?.filterDatas !== undefined ? props?.filterDatas : filterDatas;
    let clientInfos = await getClientInfo(totalCount, pageBefore, propSortFlg, propSortNm, propFilterDatas);
    if (clientInfos) {
      let filteredData = clientInfos ? clientInfos?.data : [];
      filteredData?.map((data, index) => {
        // CSV内容
        str +=
          '\n' +
          data.id +
          ',' +
          (index + 1) +
          ',' +
          data.code +
          ',' +
          data.info.branchNum +
          ',' +
          data.name +
          ',' +
          data.info.nameKana +
          ',' +
          isCustomer(data.clientType) +
          ',' +
          (isCustomer(data.clientType) && data.coeffClients
            ? data.coeffClients?.find((item) => item.clientType === ClientType.Customer)?.coeff
            : '') +
          ',' +
          isSupplier(data.clientType) +
          ',' +
          (isSupplier(data.clientType) && data.coeffClients
            ? data.coeffClients?.find((item) => item.clientType === ClientType.Supplier)?.coeff
            : '') +
          ',' +
          isContractor(data.clientType) +
          ',' +
          (isContractor(data.clientType) && data.coeffClients
            ? data.coeffClients?.find((item) => item.clientType === ClientType.Contractor)?.coeff
            : '') +
          ',' +
          data.info.tel +
          ',' +
          data.info.fax +
          ',' +
          data.info.contactParson +
          ',' +
          data.info.mail +
          ',' +
          data.info.zip +
          ',' +
          data.info.prefecture +
          ',' +
          data.info.address +
          ',' +
          data.info.sortNum +
          ',' +
          formatDate(data.created) +
          ',' +
          formatDate(data.modified) +
          ',' +
          data.modifier +
          ',' +
          data.info.remarks +
          ',' +
          data.info.isUsed;
      });
    }
    return str;
  };

  // CSV入力情報
  const submitCsvImportData = async (dataList) => {
    let clientType = 0;
    let coeffs = [];
    let failedDatas = [];
    messageRef.current = [];
    let createdDataInfo = [];
    let tempDatas = [];
    props?.loading(true); // Waitingダイアログを表示にする
    // ヘッダの情報
    if (JSON.stringify(dataList[0]) !== JSON.stringify(getCSVHeaderInfo())) {
      // 不正なヘッダの情報
      messageRef?.current?.push(<li>{ErrorMessage('1行目').E016}</li>);
    } else {
      for (let i = 1; i < dataList.length; i++) {
        let info = {
          isUsed: true,
          branchNum: '',
          nameKana: '',
          tel: '',
          fax: '',
          contactParson: '',
          mail: '',
          zip: '',
          prefecture: '',
          address: '',
          remarks: '',
          sortNum: '',
        };
        let tempData = {
          id: 0,
          code: '',
          name: '',
          clientType: '',
          coeffClients: '',
          info: info,
          created: today,
          modified: today,
        };
        clientType = 0;
        coeffs = [];
        let data = dataList[i].split(',');
        if (data && data?.[0].length === 0) continue;
        if (!csvImportDataValidation(i + 1, data)) {
          failedDatas.push(dataList[i]);
          continue;
        }
        if (JSON.parse(data?.[6]?.toLowerCase()) === true) {
          clientType = ClientType.Customer;
          coeffs.push({
            clientType: ClientType.Customer,
            coeff: data?.[7] ? parseFloat(data?.[7]) : 0.0,
          });
        }
        if (JSON.parse(data?.[8]?.toLowerCase()) === true) {
          clientType = clientType + ClientType.Supplier;
          coeffs.push({
            clientType: ClientType.Supplier,
            coeff: data?.[9] ? parseFloat(data?.[9]) : 0.0,
          });
        }
        if (JSON.parse(data?.[10]?.toLowerCase()) === true) {
          clientType = clientType + ClientType.Contractor;
          coeffs.push({
            clientType: ClientType.Contractor,
            coeff: data?.[11] ? parseFloat(data?.[11]) : 0.0,
          });
        }
        tempData.id = data?.[0];
        tempData.code = data?.[2];
        tempData.info.branchNum = data?.[3];
        tempData.name = data?.[4];
        tempData.info.nameKana = data?.[5];
        tempData.clientType = clientType;
        tempData.coeffClients = coeffs;
        tempData.info.tel = data?.[12];
        tempData.info.fax = data?.[13];
        tempData.info.contactParson = data?.[14];
        tempData.info.mail = data?.[15];
        tempData.info.zip = data?.[16];
        tempData.info.prefecture = data?.[17];
        tempData.info.address = data?.[18];
        tempData.info.sortNum = data?.[19];
        tempData.info.remarks = data?.[23];
        tempData.info.isUsed = data?.[24] ? JSON.parse(data?.[24]?.toLowerCase()) : data?.[24]; // IQX_WEBEST-301
        tempDatas.push(tempData);
      }
      let pageBefore =
        props.initialParam === 'customer' && props?.rowSelectPage !== undefined && props?.rowSelectPage !== 0
          ? props?.rowSelectPage - 1
          : 0;
      let propSortFlg =
        props.initialParam === 'customer' && props?.ascSortFlg !== undefined ? props?.ascSortFlg : ascSortFlg;
      let propSortNm = props.initialParam === 'customer' && props?.sortNm !== undefined ? props?.sortNm : sortNm;
      let propFilterDatas =
        props.initialParam === 'customer' && props?.filterDatas !== undefined ? props?.filterDatas : filterDatas;
      createdDataInfo = await createClientCSV(
        tempDatas,
        pageSize,
        pageBefore,
        propSortFlg,
        propSortNm,
        propFilterDatas
      );
      if (createdDataInfo) {
        let createdDatas = createdDataInfo?.data;
        if (createdDatas !== undefined && createdDatas?.length > 0) {
          setCurrentData(createdDatas);
          setFilteredData(createdDatas?.filter((item) => item.info.isUsed === true));
          setTotalCount(createdDataInfo?.totalCount);
          setSupplierData(createdDatas);
          setCusSelectedRowId(createdDatas?.[0]?.id);
          setSupSelectedRowId(createdDatas?.[0]?.id);
          setSelectedData(createdDatas?.[0]);
          setSelectedRowsData(createdDatas?.[0]);
          props?.updateSelectedRowId(createdDatas?.[0]?.id, 0, cusCurrentPage, ascSortFlg, sortNm, filterDatas);
          // onRowSelectWithoutEditMode(createdDatas?.[0]);
        }
      }
    }
    Modal.success({
      width: 500,
      className: 'modal-complete csv-modal-complete',
      title: '完了',
      content: (
        <p style={{ fontSize: '13.5px', whiteSpace: 'pre-line', lineHeight: 2 }}>
          {'CSV入力のデータ保存は完了しました。正常：' + tempDatas?.length + '件、異常：' + failedDatas?.length + '件'}
          {messageRef.current?.length > 0 ? (
            <>
              <br></br>
              {'下記の内容をご確認ください。'}
              <br></br>
              <ul>{messageRef.current}</ul>
            </>
          ) : (
            <></>
          )}
        </p>
      ),
    });
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  // CSV入力情報チェック
  const csvImportDataValidation = (lineNo, data) => {
    // CSV入力情報チェック
    let no = lineNo + '行目の';

    // コード
    let input = data?.[2];
    if (input?.length <= 0) {
      // 必須
      messageRef.current.push(<li>{no + ErrorMessage('コード').E007}</li>);
      return false;
    }

    // 枝番
    input = data?.[3];
    const updatedBranch = input?.trim() === '' ? 0 : input;
    if (updatedBranch?.length > 0 && !isDigit(updatedBranch?.replace(/ /g, ''))) {
      messageRef.current.push(<li>{no + ErrorMessage('枝番').E009}</li>);
      return false;
    }

    // 名称
    input = data?.[4];
    if (input?.length <= 0) {
      // 必須
      messageRef.current.push(<li>{no + ErrorMessage('名称').E007}</li>);
      return false;
    }

    // お客様係数
    if (data?.[6] && JSON.parse(data?.[6]?.toLowerCase())) {
      input = data?.[7];

      if (input?.length <= 0) {
        // 必須
        messageRef.current.push(<li>{no + ErrorMessage('お客様係数').E007}</li>);
        return false;
      }

      if (input?.length > 0 && !isDecimal(input)) {
        messageRef.current.push(<li>{no + ErrorMessage('お客様係数').E014}</li>);
        return false;
      }
    }

    // 仕入先係数
    if (data?.[8] && JSON.parse(data?.[8]?.toLowerCase())) {
      input = data?.[9];

      if (input?.length <= 0) {
        // 必須
        messageRef.current.push(<li>{no + ErrorMessage('仕入先係数').E007}</li>);
        return false;
      }

      if (input?.length > 0 && !isDecimal(input)) {
        messageRef.current.push(<li>{no + ErrorMessage('仕入先係数').E014}</li>);
        return false;
      }
    }

    // 委託先係数
    if (data?.[10] && JSON.parse(data?.[10]?.toLowerCase())) {
      input = data?.[11];

      if (input?.length <= 0) {
        // 必須
        messageRef.current.push(<li>{no + ErrorMessage('委託先係数').E007}</li>);
        return false;
      }

      if (input?.length > 0 && !isDecimal(input)) {
        messageRef.current.push(<li>{no + ErrorMessage('委託先係数').E014}</li>);
        return false;
      }
    }

    // Tel
    input = data?.[12];
    if (input?.length > 0 && !isTelAndFax(input)) {
      messageRef.current.push(<li>{no + ErrorMessage('Tel').E008}</li>);
      return false;
    }

    // Fax
    input = data?.[13];
    if (input?.length > 0 && !isTelAndFax(input)) {
      messageRef.current.push(<li>{no + ErrorMessage('Fax').E008}</li>);
      return false;
    }

    // メール
    input = data?.[15];
    if (input?.length > 0 && !isEmail(input)) {
      messageRef.current.push(<li>{no + ErrorMessage('メール').E008}</li>);
      return false;
    }

    // 郵便番号
    input = data?.[16];
    if (input?.length > 0 && !isTelAndFax(input)) {
      messageRef.current.push(<li>{no + ErrorMessage('郵便番号').E008}</li>);
      return false;
    }

    // ソート番号
    input = data?.[19];
    if (input?.length > 0 && !isDigit(input)) {
      messageRef.current.push(<li>{no + ErrorMessage('ソート番号').E009}</li>);
      return false;
    }

    return true;
  };

  // CSV入力ボタンを押下した場合、
  const onClickCSVImport = () => {
    props?.onClickCSVImport();
  };

  // CSV出力ボタンを押下した場合、
  const onClickCSVExport = () => {
    props?.onClickCSVExport();
  };

  return (
    <>
      {/* 一覧とプロパティ表示 */}
      <div
        style={{
          height: '90.8vh',
          marginLeft: 10,
        }}
      >
        <SplitPane split="vertical" sizes={sizes} onChange={setSizes} resizerSize={1}>
          <div style={{ marginTop: 7 }}>
            {/* 検索アリア */}
            <Space size="middle">
              <div>
                <label>お客様：</label>
                <Select
                  style={{ width: 90 }}
                  onChange={searchByCustomerFlg}
                  id="customerflgStateDrop"
                  name="customerflgStateDrop"
                  value={customerFlgState}
                >
                  {flgStateList?.map((item, index) => (
                    <Select.Option key={index} id={'customerFlgState' + item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
              <div>
                <label>仕入先：</label>
                <Select
                  style={{ width: 90 }}
                  onChange={searchBySupplierFlg}
                  id="supplierflgStateDrop"
                  name="supplierflgStateDrop"
                  value={supplierFlgState}
                >
                  {flgStateList?.map((item, index) => (
                    <Select.Option key={index} id={'supplierFlgState' + item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
              <div>
                <label>委託先：</label>
                <Select
                  className="search-select"
                  onChange={searchByContractorFlg}
                  id="contractorFlgStateDrop"
                  name="contractorFlgStateDrop"
                  value={contractorFlgState}
                >
                  {flgStateList?.map((item, index) => (
                    <Select.Option key={index} id={'contractorFlgState' + item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
              <Input
                className="input-editable search-select-input"
                id="keyword"
                name="keyword"
                placeholder="キーワードを入力"
                allowClear
                onPressEnter={searchByKeyword}
                onBlur={searchByKeyword}
                value={keyword}
                onChange={searchByKeyword}
              />
              <div>
                <label>表示：</label>
                <Select
                  style={{ width: 90 }}
                  onChange={searchByDataState}
                  id="dataStateDrop"
                  name="dataStateDrop"
                  value={dataState}
                >
                  {dataStateList?.map((item, index) => (
                    <Select.Option key={index} id={'dataState' + item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
              <Button style={{ marginLeft: 15 }} className="filterClearButton" onClick={clearAllFilter}>
                {filterClearBtn}
              </Button>
            </Space>

            {/* 一覧アリア */}
            <Row style={{ marginTop: 10 }}>
              <Table
                showSorterTooltip={false}
                columns={hasCheckData ? tableColumns : chkData}
                components={components}
                dataSource={filteredData}
                // scroll={{ y: 590, x: '10vw' }}
                scroll={{ y: tableScrollY, x: 'max-content' }}
                rowClassName={(record) => (record.id == getSelectedRowId() ? 'active-row' : 'data-row')}
                pagination={{
                  position: ['bottomLeft'],
                  total: totalCount,
                  showTotal: (total, range) => `全${total}件中${range[0]}件〜${range[1]}件を表示`,
                  // defaultPageSize: defaultPageSize,
                  defaultCurrent: 1,
                  pageSize: pageSize,
                  pageSizeOptions: pageSizes,
                  showSizeChanger: true,
                  onShowSizeChange: handlePageSizeChange,
                  current: cusCurrentPage,
                  onChange: (page) => {
                    setCusCurrentPage(page);
                  },
                }}
                // className="param_tbListShow"
                onRow={(record, index) => {
                  return {
                    onClick: (event) => {
                      onRowSelect(record);
                    },
                  };
                }}
                onChange={handleTableChange}
                loading={tblLoading}
              />
            </Row>
          </div>
          {/* プロパティ表示 */}
          <div>
            <Routes>
              <Route
                exact
                path=":common.customer"
                element={
                  <CustomerSupplierDetails
                    ref={detailRef}
                    editMode={editMode}
                    showEdtConfirmOK={showEdtConfirmOK}
                    showEdtConfirmCancle={showEdtConfirmCancle}
                    selectedData={selectedData}
                    submitData={submitData}
                    updateEditMode={updateEditMode}
                    activePartMenu={activePartMenu}
                  />
                }
              />
            </Routes>
          </div>
        </SplitPane>
      </div>

      {/* 新規作成 */}
      {isCreateNew
        ? commonModal(
            isCreateNew,
            createNewTitle,
            null,
            null,
            800,
            createNewOK,
            createNewCancel,
            createNewContent,
            'addNewCustomerModal',
            null,
            true
          )
        : ''}

      {/* 一括編集 */}
      {isBulkEdit
        ? commonModal(
            isBulkEdit,
            bulkEditTitle,
            null,
            null,
            1790,
            bulkEditOK,
            bulkEditCancel,
            bulkEditContent,
            'updateModalStyle',
            null,
            true
          )
        : ''}

      {/* 削除 */}
      {isDelete
        ? commonResponsiveConfirmModal(
            isDelete,
            confirmModalTitle,
            commonDeleteFooter(deleteOk, deleteCancel),
            null,
            400,
            deleteOk,
            deleteCancel,
            editMode ? confirmDiscardAndDeleteContent : confirmDeleteContent,
            null,
            null,
            false
          )
        : ''}

      {/* 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい */}
      {isBulkDelete && (
        <BulkDeleteModal
          isOpen={isBulkDelete}
          title={bulkDeleteModalTitle}
          loading={bulkDeleteLoading}
          data={filteredData}
          deleteRowSelection={deleteRowSelection}
          tableColumns={tableColumns}
          page={cusCurrentPage}
          pageSize={pageSize}
          totalCount={totalCount}
          handlePageChange={(page) => setCusCurrentPage(page)}
          handleSelectAll={handleSelectAll}
          bulkDeleteOk={bulkDeleteOk}
          bulkDeleteCancel={bulkDeleteCancel}
          setDeleteSelectedRowKeys={setDeleteSelectedRowKeys}
        />
      )}

      {/* CSV取込 */}
      {/* <Modal
        title={reportModalTitle}
        open={visibleCSVInput}
        onOk={handleOkCSVInput}
        onCancel={handleCancel}
        footer={[
          <Button key="file" type="primary" onClick={handleOkCSVInput} className="mainButton">
            OK
          </Button>,
          <Button key="back" onClick={handleCancel} className="cancelButton">
            キャンセル
          </Button>,
        ]}
        closeIcon={<CloseOutlined style={{ color: 'white' }} />}
      >
        <p style={{ fontSize: '13.5px' }}>
          PCに保存した情報を読み込みます。<br></br>よろしいでしょうか？
        </p>
      </Modal> */}

      {/* XML呼出 */}
      {/* <Modal
        title={reportModalTitle}
        open={visibleXMLInput}
        onOk={handleOkXMLInput}
        onCancel={handleCancel}
        footer={[
          <Button key="file" type="primary" onClick={handleOkXMLInput} className="mainButton">
            OK
          </Button>,
          <Button key="back" onClick={handleCancel} className="cancelButton">
            キャンセル
          </Button>,
        ]}
        closeIcon={<CloseOutlined style={{ color: 'white' }} />}
      >
        <p style={{ fontSize: '13.5px' }}>
          装置情報（時間チャージ、段取設定、加工設定）を初期パラメータ作成情報から
          <br />
          取り込みます。
          <br />
          装置情報は、呼出情報で更新されます。
        </p>
      </Modal> */}

      {/* 登録確認 */}
      {createConfirm
        ? commonResponsiveConfirmModal(
            createConfirm,
            confirmModalTitle,
            commonFooter(confirmOk, confirmCancel),
            null,
            400,
            confirmOk,
            confirmCancel,
            confirmCreateContent,
            null,
            null,
            false
          )
        : ''}

      {/* 更新確認 */}
      {updateConfirm
        ? commonResponsiveConfirmModal(
            updateConfirm,
            confirmModalTitle,
            commonFooter(confirmOk, confirmCancel),
            null,
            400,
            confirmOk,
            confirmCancel,
            confirmUpdateContent,
            null,
            null,
            false
          )
        : ''}

      {/** 破棄の確認メッセージ */}
      {cancelConfirm
        ? commonResponsiveConfirmModal(
            cancelConfirm,
            confirmModalTitle,
            commonFooter(cancelConfirmOK, cancelConfirmCancel),
            null,
            400,
            cancelConfirmOK,
            cancelConfirmCancel,
            confirmDiscardContent,
            null,
            null,
            false
          )
        : ''}

      {/** 編集中破棄確認ポップアップ */}
      {editModeCancelConfirm
        ? commonResponsiveConfirmModal(
            editModeCancelConfirm,
            confirmModalTitle,
            commonFooter(discardConfirmOk, discardConfirmCancel),
            null,
            400,
            discardConfirmOk,
            discardConfirmCancel,
            confirmHakiContent,
            null,
            null,
            false
          )
        : ''}

      {isDeleteAll && (
        <Modal
          maskClosable={false}
          open={isDeleteAll}
          title={deleteModalTitle}
          footer={commonDeleteAllFooter(deleteAllRecord, deleteAllCancel)}
          width={400}
          onOk={deleteAllRecord}
          onCancel={deleteAllCancel}
          closeIcon={<CloseOutlined style={{ color: 'white' }} />}
          centered={false}
          modalRender={(modal) => (
            <Draggable handle=".ant-modal-header">
              <div>{modal}</div>
            </Draggable>
          )}
        >
          <div>
            <p style={{ fontSize: '13px', marginBottom: '20px' }}>すべてのデータを削除しますがよろしいですか。</p>
          </div>
        </Modal>
      )}
    </>
  );
});

export default CustomerSupplierParamList;
